import { render } from "./CollectionDetailedSearchBooks.vue?vue&type=template&id=4228b8a0&scoped=true&ts=true"
import script from "./CollectionDetailedSearchBooks.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchBooks.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchBooks.vue?vue&type=style&index=0&id=4228b8a0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4228b8a0"]])

export default __exports__